import httpManager from "@/app/shared/utils/httpManager";
/**
 * Eliminar estrategia por identificador.
 *
 * @param {number} strategyId Identificador de la estrategia.
 */
export async function deleteStrategy(strategyId) {
  await httpManager.delete(`/strategies/${strategyId}/`);
}
